import { DeviceIdentificationType } from '@quadminds/shared/tracking-system';

export interface IDeviceIdentificationSchema {
    type: DeviceIdentificationType;
    value: string;
    allIdentifiers: string[];
}
